import React from 'react';
import PartsBlade from '../../pages/MechanicOrdersPage/PartsBlade';
import { Box } from '@mui/material';

export default function PartsTab({ order, stockNumber, setOrder }) {
  const handlePartsUpdate = (updatedParts) => {
    setOrder(prevOrder => ({
      ...prevOrder,
      parts: updatedParts
    }));
  };

  return (
    <Box>
      <PartsBlade
        order={{
          ...order,
          id: stockNumber
        }}
        onClose={() => {}}
        onUpdate={handlePartsUpdate}
      />
    </Box>
  );
}

